import { Link } from "react-router-dom";
import { openPreferences } from "../lib/consent";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative mt-20 pb-10">
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent, rgba(11,13,35,0.08), transparent)",
        }}
      />
      <div className="container-xl pt-14">
        <div className="glass-strong rounded-3xl p-8 sm:p-12 relative overflow-hidden">
          {/* decorative orbs */}
          <div
            aria-hidden
            className="absolute -top-20 -right-20 h-72 w-72 rounded-full blur-3xl opacity-40"
            style={{ background: "radial-gradient(closest-side, #93ddd9, transparent)" }}
          />
          <div
            aria-hidden
            className="absolute -bottom-20 -left-20 h-72 w-72 rounded-full blur-3xl opacity-40"
            style={{ background: "radial-gradient(closest-side, #d7c8ff, transparent)" }}
          />
          <div className="relative grid gap-10 md:grid-cols-4">
            <div className="md:col-span-2">
              <img
                src="/sanctology-wordmark.svg"
                alt="Sanctology — Sanctuary of Hope"
                className="h-12 w-auto mb-5"
              />
              <p className="text-ink-500 max-w-md leading-relaxed">
                Sanctology Welfare Foundation is the CSR arm of Logy Holdings —
                a sanctuary for homeless elders and orphaned children, funded
                by our sibling companies so care can be given without asking.
              </p>
              <address className="not-italic mt-5 text-sm text-ink-500 leading-relaxed">
                3/5, Panchayat Board St, Karuthapillaiyur,
                <br />
                Tirunelveli, Tamil Nadu 627418, India
                <br />
                <a
                  href="mailto:hope@sanctology.com"
                  className="hover:text-royal transition"
                >
                  hope@sanctology.com
                </a>
              </address>
            </div>

            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-500 mb-3">
                Programs
              </div>
              <ul className="space-y-2 text-sm text-ink-700">
                <li><Link to="/elder-sanctuary" className="hover:text-royal transition">Elder Sanctuary</Link></li>
                <li><Link to="/orphan-sanctuary" className="hover:text-royal transition">Orphan Sanctuary</Link></li>
                <li><Link to="/volunteer" className="hover:text-royal transition">Volunteer</Link></li>
              </ul>
            </div>

            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-500 mb-3">
                Logy family
              </div>
              <ul className="space-y-2 text-sm text-ink-700">
                <li>
                  <a
                    href="https://chaosology.com"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-royal transition inline-flex items-center gap-1"
                  >
                    Chaosology ↗
                  </a>
                </li>
                <li>
                  <a
                    href="https://boreology.com"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-royal transition inline-flex items-center gap-1"
                  >
                    Boreology ↗
                  </a>
                </li>
                <li>
                  <a
                    href="https://lectureology.com"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-royal transition inline-flex items-center gap-1"
                  >
                    Lectureology ↗
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative mt-10 pt-6 border-t border-ink-200/60 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-ink-500">
            <div>
              © {year} Sanctology Welfare Foundation. A Section 8 not-for-profit
              under Logy Holdings.
            </div>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
              <Link to="/privacy" className="hover:text-royal transition">
                Privacy
              </Link>
              <Link to="/cookies" className="hover:text-royal transition">
                Cookies
              </Link>
              <button
                type="button"
                onClick={openPreferences}
                className="hover:text-royal transition cursor-pointer"
                data-consent-open
              >
                Cookie preferences
              </button>
              <span className="font-mono tracking-[0.12em] uppercase text-ink-400">
                Funded by Chaosology · Boreology · Lectureology
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
